import { render, staticRenderFns } from "./choice.vue?vue&type=template&id=63df5957&scoped=true"
import script from "./choice.vue?vue&type=script&lang=js"
export * from "./choice.vue?vue&type=script&lang=js"
import style0 from "./choice.vue?vue&type=style&index=0&id=63df5957&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63df5957",
  null
  
)

export default component.exports